import React, { useState } from 'react';
import { Modal } from '@amzn/stencil-react-components/modal';
import { Col, Row, Spacer, View } from '@amzn/stencil-react-components/layout';
import { Label, H2, H3, Text } from '@amzn/stencil-react-components/text';
import { Button } from '@amzn/stencil-react-components/button';

import Slide1 from './Slide1';
import Slide2 from './Slide2';
import Slide3 from './Slide3';
import Slide4 from './Slide4';

const SlideIndicator = ({ slideNumber, isActive, clickHandlerCallback }) => {
  return (
    <View
      onClick={() => {
        clickHandlerCallback(slideNumber);
      }}
      backgroundColor={isActive ? 'primary' : 'neutral30'}
      className="rounded-circle"
      minWidth={20}
      minHeight={20}
      style={{ borderRadius: '20px', cursor: 'pointer' }}
    />
  );
};

const WelcomeSlides = ({ isOpen, close }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  return (
    <Modal isOpen={isOpen} close={close} height={'60%'} width={'80%'}>
      <Col
        data-testid="welcome-slide"
        backgroundColor="neutral0"
        gridGap="S500"
        padding="S500"
        alignItems="center"
      >
        {/* <H2>Welcome to Nudge Engine</H2>
        <Text>Content to display useful info about new features</Text> */}
        <Col maxHeight={'500px'} width={'800px'}>
          {currentSlide === 0 && <Slide1 />}
          {currentSlide === 1 && <Slide2 />}
          {currentSlide === 2 && <Slide3 />}
          {currentSlide === 3 && <Slide4 />}
        </Col>
        <Spacer />
        <Row gridGap="S200">
          <SlideIndicator
            slideNumber={0}
            clickHandlerCallback={setCurrentSlide}
            isActive={currentSlide === 0}
          />
          <SlideIndicator
            slideNumber={1}
            clickHandlerCallback={setCurrentSlide}
            isActive={currentSlide === 1}
          />
          <SlideIndicator
            slideNumber={2}
            clickHandlerCallback={setCurrentSlide}
            isActive={currentSlide === 2}
          />
          <SlideIndicator
            slideNumber={3}
            clickHandlerCallback={setCurrentSlide}
            isActive={currentSlide === 3}
          />
        </Row>
        <Row alignSelf="end">
          {currentSlide !== 3 && (
            <Button
              onClick={() => {
                setCurrentSlide(currentSlide + 1);
              }}
              primary
            >
              Next
            </Button>
          )}
          {currentSlide === 3 && (
            <Button data-testid="welcome-slide-close-btn" onClick={close} primary>
              Close
            </Button>
          )}
        </Row>
      </Col>
    </Modal>
  );
};

export default WelcomeSlides;
